export const STORAGE_KEY = "care-outcomes-dashboard-v1";

export const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(Number(value));
};

export const getReadinessBand = (bands = [], score = 0) => {
  return bands.find((band) => score >= band.min && score <= band.max) || bands[bands.length - 1];
};

export const buildDefaultAssessment = (categories = []) => ({
  categories: categories.map((category) => ({
    slug: category.slug,
    title: category.title,
    weight: category.weight,
    rationale: category.rationale,
    questions: category.questions.map((question) => ({
      slug: question.slug,
      title: question.title,
      prompt: question.prompt,
      low_hint: question.low_hint,
      high_hint: question.high_hint,
      score: 5,
      explanation: "",
    })),
  })),
});

export const buildDefaultValuation = (meta) => ({
  industry_slug: meta?.industry_benchmarks?.[0]?.slug || "other",
  gross_revenue: "",
  sde: "",
  ebitda: "",
  net_assets: "",
  multiple_overrides: {
    sales_multiple: "",
    sde_multiple: "",
    ebitda_multiple: "",
  },
  qualitative_scores: (meta?.qualitative_factors || []).reduce((accumulator, factor) => {
    accumulator[factor.slug] = 3;
    return accumulator;
  }, {}),
});

export const buildInitialState = (meta) => ({
  client: {
    client_name: "",
    client_email: "",
    client_phone: "",
    business_name: "",
    planned_exit_years: 3,
  },
  assessment: buildDefaultAssessment(meta?.readiness_categories || []),
  valuation: buildDefaultValuation(meta),
  report: null,
});

export const parseNumericField = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? null : numericValue;
};

export const sanitisePayload = (state) => ({
  client_name: state.client.client_name,
  client_email: state.client.client_email,
  client_phone: state.client.client_phone || "",
  business_name: state.client.business_name,
  planned_exit_years: Number(state.client.planned_exit_years) || 3,
  assessment: {
    categories: state.assessment.categories.map((category) => ({
      slug: category.slug,
      title: category.title,
      weight: Number(category.weight) || 0,
      questions: category.questions.map((question) => ({
        slug: question.slug,
        title: question.title,
        score: Number(question.score),
        explanation: question.explanation || "",
      })),
    })),
  },
  valuation: {
    industry_slug: state.valuation.industry_slug,
    gross_revenue: Number(state.valuation.gross_revenue) || 0,
    sde: Number(state.valuation.sde) || 0,
    ebitda: parseNumericField(state.valuation.ebitda),
    net_assets: parseNumericField(state.valuation.net_assets),
    multiple_overrides: {
      sales_multiple: parseNumericField(state.valuation.multiple_overrides.sales_multiple),
      sde_multiple: parseNumericField(state.valuation.multiple_overrides.sde_multiple),
      ebitda_multiple: parseNumericField(state.valuation.multiple_overrides.ebitda_multiple),
    },
    qualitative_scores: Object.fromEntries(
      Object.entries(state.valuation.qualitative_scores).map(([key, value]) => [key, Number(value)])
    ),
  },
});

export const isClientComplete = (client) =>
  Boolean(client.client_name && client.client_email && client.business_name);
